import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

import Justine from "../../assets/justine-profil.webp";
import CV from "../../assets/CV_Justine_Provent.pdf";
// import Diplôme from "../../assets/Diplome web dev.pdf";
import "./Who.scss";

const Who = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div id="who">
      <div /* data-aos="fade-right"*/>
        <h2>Qui suis-je ?</h2>
        <div className="who-content">
          <div className="who-media">
            Je conçois des interfaces web simples, efficaces et agréables à
            utiliser. Après un Master en Marketing & Stratégies Digitales à
            l'INSEEC, j'ai évolué dans les univers de la communication, du
            e-commerce et du digital. J'ai notamment travaillé chez
            Happywool.com où j'ai participé à la refonte complète du site
            e-commerce : conception de maquettes UX/UI, amélioration des
            parcours utilisateurs, création et intégration de newsletters HTML,
            ainsi que collaboration avec les équipes de développement. Mon
            parcours me permet aujourd'hui de faire le lien entre les enjeux
            business, l'expérience utilisateur et les contraintes techniques.
          </div>
          <div className="who-picture">
            <img
              className="justine-profil"
              src={Justine}
              alt="justine-profil"
            ></img>
            <a
              className="center"
              href={CV}
              alt="CV_Justine_Provent"
              target="_blank"
              rel="noreferrer"
            >
              <button className="button">Voir mon CV 🚀</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Who;
